import {FileFormatType} from './constants';
import {fileFormatRuleDefaults} from './defaults';
import {FileFormatRule} from './types';

type GetFileFormatRuleParams = {
	fileFormat: string;
	type: FileFormatType;
};

export const createFileFormatRule = ({
	fileFormat,
	type,
}: GetFileFormatRuleParams): FileFormatRule => ({
	...fileFormatRuleDefaults,
	elementSubType1: type,
	elementValue1: fileFormat,
});

export default createFileFormatRule;
